import _ from 'lodash';

// eslint-disable-next-line max-len
export const EMAIL_RE =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const URL_RE = /^(?:\w+:\/\/)?([^@^\s.]+\.\S{2}|localhost[:?\d]*)\S*$/i;
export const PHONE_RE = /^[\d+\-() ]+$/i;

export const getErrorTexts = _.memoize((i18n) => ({
    REQUIRED: i18n('forms', 'label_error-required'),
    MAX_LEN: i18n('forms', 'label_error-max-length'),
    FORMAT: i18n('forms', 'label_error-format'),
    URL: i18n('forms', 'label_error-url'),
}));

export function isEmpty(value) {
    return !value || value.length === 0;
}

export function maxLength(value, length) {
    return value.length <= length;
}

export function matchRegexp(value, regexp) {
    return regexp.test(value);
}
